import { BaseService } from 'iui-iconectiv-lib';
import { Injectable } from '@angular/core';
import { Subject, Observable, Observer } from 'rxjs';

@Injectable()
export class WebSocketService extends BaseService {

  private socket: Subject<MessageEvent>;
  private ws: WebSocket;
  private messageQueue: string[] = [];
  private pingTimer: any;

  public connect(url): Subject<MessageEvent> {
    if (!this.socket) {
      this.socket = this.create(url);
    }
    return this.socket;
  }

  public isOpen(): boolean {
    return (this.ws) && (this.ws.readyState === WebSocket.OPEN);
  }

  public close() {
    this.ws.close();
    delete this.socket;
  }

  public send(data: any) {
    const msg = JSON.stringify(data);
    if (this.ws.readyState === this.ws.OPEN) {
      this.ws.send(msg);
    }
    else {
      this.messageQueue.push(msg);
    }
  }

  private create(url): Subject<MessageEvent> {
    let previousMessageId: string;
    this.ws = new WebSocket(url);
    this.pingTimer = setInterval(() => {
      if (this.ws.readyState === WebSocket.OPEN) {
        this.log.debug('pinging event service');
        this.ws.send(JSON.stringify({ 'messageType': 'ping' }));
      }
    }, 60 * 1000);
    const observable = Observable.create(
      (obs: Observer<MessageEvent>) => {
        this.ws.onopen = () => {
          this.messageQueue.forEach(m => this.ws.send(m));
          this.messageQueue = [];
          this.log.debug('websocket opened');
        };
        this.ws.onmessage = (m: MessageEvent) => {
          const o = JSON.parse(m.data);
          this.log.debug('on message ' + o.messageType);
          if ('pong' !== o.messageType) {
            if (o.messageId) {
              if (o.messageId !== previousMessageId) {
                obs.next(m);
              }
              previousMessageId = o.messageId;
            }
            else {
              obs.next(m);
            }
          }
        };
        this.ws.onerror = (e: Event) => {
          this.log.debug('on error ' + e);
          obs.error(e);
        };
        this.ws.onclose = (e: CloseEvent) => {
          this.log.debug('received close event ' + e.code + ' ' + e.reason + ' ' + e.wasClean);
          if (this.pingTimer) {
            clearInterval(this.pingTimer);
            delete this.pingTimer;
          }
          obs.complete();
        };
        return this.ws.close.bind(this.ws);
      }
    );
    const observer = {
      next: (data: Object) => {
        if (this.ws.readyState === WebSocket.OPEN) {
          this.ws.send(JSON.stringify(data));
        }
      },
    };
    return Subject.create(observer, observable);
  }
}
